import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { shareReplay, tap, map } from 'rxjs/operators';

import { environment } from '@environments/environment';

export interface DeltaNextModule {
  name: string;
  apiRoute: string;
  description: string;
  localizedName?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AppsService {

  private readonly APP_LOCALIZATIONS: Record<string, string> = {
    'Projects': $localize`:@@projectsTitle:Projects`,
    'Organizations': $localize`:@@organizationsTitle:Organizations`,
    'DeltaCubes': $localize`:@@deltaCubesTitle:DeltaCubes`
  };

  constructor(private http: HttpClient) {
  }

  getApps() {
    return this.http.get<DeltaNextModule[]>(`${environment.apiUrl}/modules`)
    .pipe(
      shareReplay(),
      map((apps: DeltaNextModule[]) => this.localizeApps(apps))
    );
  }

  private localizeApps(apps: DeltaNextModule[]): DeltaNextModule[] {
    return apps.map(a => {
      return {
        ...a,
        localizedName: this.APP_LOCALIZATIONS[a.name] || a.name
      };
    });
  }

}
